import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../store/actions/profileActions';
import '../../assets/css/style.css';

const ProfileDoB = () => {
    const profile = useSelector(state => state.profile.profile);
    const dispatch = useDispatch();
    
    const handleChange = (e) => {
        dispatch(action.collectProfileData({...profile, dateOfBirth: e.target.value}));
    }

    return (
        <div className="uni-form">
            <input className="uni-text" value={profile.dateOfBirth} onChange={handleChange} type="date" id="name" placeholder="YYYY-MM-DD" required />
            <h6 className="field-warning">Keep in mind that you won't be able to change your age</h6>
        </div>
    );
};

export default ProfileDoB;